import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import Styles from "./FormError.module.scss"

export const WithErrorLabel = Component => {
  const Label = props => {
    const { field, form } = props

    if (!form) {
      return <Component {...props} />
    }

    const errors = form.errors
    const name = field.name

    const isError = IsError(field, form)

    return (
      <div
        className={classnames({
          [Styles.error]: isError,
        })}
      >
        <Component {...props} />
        {isError && errors[name] && typeof errors[name] !== 'boolean' && (
          <div data-error-label className={Styles['error-label']}>
            {errors[name]}
          </div>
        )}
      </div>
    )
  }

  Label.propTypes = {
    form: PropTypes.object,
    field: PropTypes.object,
  }

  return Label
}

function findByPath(result, pathItem) {
  if (result && result[pathItem]) {
    return result[pathItem]
  }
  return false
}

export const IsError = (field, form) => {
  const touched = form.touched
  const errors = form.errors
  const name = field.name

  // For Formik FieldArray
  if (name.indexOf(".") > 0) {
    const path = name.split(".")

    const isTouched = path.reduce(findByPath, touched)
    const hasErrors = path.reduce(findByPath, errors)

    return isTouched && hasErrors
  }

  return touched[name] && errors[name]
}
